export default __webpack_public_path__ + "static/media/brand_13.4d2e6e4b.png";